import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { add, search, getEncryptedPassword } from '../../context/users/UserActions'
import { useUserContext } from '../../context/users/UserContext'
import { 
  FaEye, 
  FaEyeSlash, 
  FaArrowLeft, 
  FaUserPlus, 
  FaEnvelope, 
  FaUser, 
  FaGlobe, 
  FaSave, 
  FaShieldAlt,
  FaExclamationTriangle,
  FaCheckCircle
} from 'react-icons/fa'
import { Card, Row, Col, Form, Button } from 'react-bootstrap'
import Logo from '../layout/assets/logo.png'
import './AddUser.css'

// eslint-disable-next-line
export default function (props) {
  const EMAIL_REGEX = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/
  const navigate = useNavigate()
  const { uses, setUses, setAlert } = useUserContext()

  const [userEmail, setEmail] = useState('')
  const [validEmail, setValidEmail] = useState(true)
  const [password, setPass] = useState('')
  const [showPass, setShowPass] = useState(false)
  const [confirmPassword, setConfirmPass] = useState('')
  const [showConfirmPass, setShowConfirmPass] = useState(false)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [country, setCountry] = useState('')
  const [useId, setUseId] = useState('')
  const [position, setPosition] = useState('')
  const [licenseCode, setLicenseCode] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  
  const handleChangeEmail = (e) => {
    setEmail(e.target.value)
    if(e.target.value === '') {
      setValidEmail(true)
    } else {
      setValidEmail(EMAIL_REGEX.test(e.target.value))
    }
  }

  const handleChangePass = (e) => setPass(e.target.value)
  const handleChangeConfirmPass = (e) => setConfirmPass(e.target.value)

  const handleChangeShowPass = (e) => {
    e.preventDefault()
    setShowPass(!showPass)
  }

  const handleChangeShowConfirmPass = (e) => {
    e.preventDefault()
    setShowConfirmPass(!showConfirmPass)
  }

  const handleChangeFirstName = (e) => setFirstName(e.target.value)
  const handleChangeLastName = (e) => setLastName(e.target.value)
  const handleChangeCountry = (e) => setCountry(e.target.value)
  const handleChangeUseId = (e) => setUseId(e.target.value)
  const handleChangePosition = (e) => setPosition(e.target.value)
  const handleChangeLicenseCode = (e) => setLicenseCode(e.target.value)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    if(!validEmail) {
      setAlert({
        message: 'Por favor ingresa el correo electrónico con formato válido.',
        msgType: 'warning'
      })
      setIsLoading(false)
      return
    }

    if(password !== confirmPassword) {
      setAlert({
        message: 'Las contraseñas no coinciden.',
        msgType: 'warning'
      })
      setIsLoading(false)
      return
    }

    if(firstName === '' || password === '' || licenseCode === '') {
      setAlert({
        message: 'Por favor ingresa todos los datos requeridos',
        msgType: 'warning'
      })
      setIsLoading(false)
      return
    }

    try {
      const record = await getEncryptedPassword(password)
      const userData = await add({ 
        path: 'users/registry',
        data: {
          userEmail: userEmail.trim(),
          userPass: record.userPass.trim(),
          firstName,
          lastName,
          country,
          useId,
          position,
          licenseCode,
          host: window.location.origin,
          roles: ['ANFITRION'],
          pendingPlan: false,
        }, 
        token: '' 
      })

      if(Object.prototype.hasOwnProperty.call(userData, 'userId')) {
        setAlert({
          message: '¡Registro exitoso! Serás redirigido en unos segundos.',
          msgType: 'success'
        })
        setTimeout(() => {
          navigate('/welcome')
        }, 2000)
      } else {
        setAlert({
          message: userData.message || userData,
          msgType: 'warning'
        })
      }
    } catch (error) {
      setAlert({
        message: 'Error en el servidor. Por favor intenta más tarde.',
        msgType: 'danger'
      })
    }
    setIsLoading(false)
  }

  useEffect(() => {
    const fetchData = async () => {
      const response = await search({ path: 'uses', type: 'licencia', token: '' })
      if (response.error) {
        setUses([])
      } else {
        setUses(response.data)
      }
    }
    fetchData()
  }, [setUses])

  return (
    <div className="add-user-container">
      <div className="container">
        <Row className="justify-content-center">
          <Col lg={8} md={10} sm={12}>
            {/* Header */}
            <div className="page-header">
              <div className="header-content">
                <div className="header-icon">
                  <FaUserPlus />
                </div>
                <div className="header-text">
                  <h1>Registro de Usuario Anfitrión</h1>
                  <p>Completa la información para registrarte como usuario anfitrión en la plataforma</p>
                </div>
              </div>
            </div>

            {/* Form Card */}
            <Card className="form-card">
              <Card.Body>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    {/* License Code Field */}
                    <Col lg={6} md={12} className="mb-4">
                      <Form.Group>
                        <Form.Label className="form-label">
                          <FaShieldAlt className="field-icon" />
                          Código de Licencia
                          <span className="required-field">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Ingresa el código de tu licencia"
                          value={licenseCode}
                          onChange={handleChangeLicenseCode}
                          className="form-control-custom"
                          disabled={isLoading}
                          required
                        />
                      </Form.Group>
                    </Col>

                    {/* Email Field */}
                    <Col lg={6} md={12} className="mb-4">
                      <Form.Group>
                        <Form.Label className="form-label">
                          <FaEnvelope className="field-icon" />
                          Correo Electrónico
                          <span className="required-field">*</span>
                        </Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="usuario@ejemplo.com"
                          value={userEmail}
                          onChange={handleChangeEmail}
                          className={`form-control-custom ${!validEmail && userEmail ? 'is-invalid' : ''}`}
                          disabled={isLoading}
                          required
                        />
                        {!validEmail && userEmail && (
                          <div className="error-message">
                            <FaExclamationTriangle className="error-icon" />
                            Por favor ingresa un correo electrónico válido
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Password Field */}
                    <Col lg={6} md={12} className="mb-4">
                      <Form.Group>
                        <Form.Label className="form-label">
                          <FaShieldAlt className="field-icon" />
                          Contraseña
                          <span className="required-field">*</span>
                        </Form.Label>
                        <div className="password-field">
                          <Form.Control
                            type={showPass ? 'text' : 'password'}
                            placeholder="Ingresa tu contraseña"
                            value={password}
                            onChange={handleChangePass}
                            className="form-control-custom"
                            disabled={isLoading}
                            required
                          />
                          {password && (
                            <button 
                              type="button"
                              className="eye-button"
                              onClick={handleChangeShowPass}
                              aria-label={showPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                            >
                              {showPass ? <FaEyeSlash /> : <FaEye />}
                            </button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>

                    {/* Confirm Password Field */}
                    <Col lg={6} md={12} className="mb-4">
                      <Form.Group>
                        <Form.Label className="form-label">
                          <FaShieldAlt className="field-icon" />
                          Confirmar Contraseña
                          <span className="required-field">*</span>
                        </Form.Label>
                        <div className="password-field">
                          <Form.Control
                            type={showConfirmPass ? 'text' : 'password'}
                            placeholder="Confirma tu contraseña"
                            value={confirmPassword}
                            onChange={handleChangeConfirmPass}
                            className="form-control-custom"
                            disabled={isLoading}
                            required
                          />
                          {confirmPassword && (
                            <button 
                              type="button"
                              className="eye-button"
                              onClick={handleChangeShowConfirmPass}
                              aria-label={showConfirmPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                            >
                              {showConfirmPass ? <FaEyeSlash /> : <FaEye />}
                            </button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>

                    {/* First Name Field */}
                    <Col lg={6} md={12} className="mb-4">
                      <Form.Group>
                        <Form.Label className="form-label">
                          <FaUser className="field-icon" />
                          Nombre
                          <span className="required-field">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Nombre del usuario"
                          value={firstName}
                          onChange={handleChangeFirstName}
                          className="form-control-custom"
                          disabled={isLoading}
                          required
                        />
                      </Form.Group>
                    </Col>

                    {/* Last Name Field */}
                    <Col lg={6} md={12} className="mb-4">
                      <Form.Group>
                        <Form.Label className="form-label">
                          <FaUser className="field-icon" />
                          Apellidos
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Apellidos del usuario"
                          value={lastName}
                          onChange={handleChangeLastName}
                          className="form-control-custom"
                          disabled={isLoading}
                        />
                      </Form.Group>
                    </Col>

                    {/* Country Field */}
                    <Col lg={6} md={12} className="mb-4">
                      <Form.Group>
                        <Form.Label className="form-label">
                          <FaGlobe className="field-icon" />
                          País de Residencia
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="País donde reside el usuario"
                          value={country}
                          onChange={handleChangeCountry}
                          className="form-control-custom"
                          disabled={isLoading}
                        />
                      </Form.Group>
                    </Col>

                    {/* Position Field */}
                    <Col lg={6} md={12} className="mb-4">
                      <Form.Group>
                        <Form.Label className="form-label">
                          <FaUser className="field-icon" />
                          Cargo
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Cargo del usuario"
                          value={position}
                          onChange={handleChangePosition}
                          className="form-control-custom"
                          disabled={isLoading}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Action Buttons */}
                  <div className="form-actions">
                    <Button
                      type="button"
                      variant="outline-secondary"
                      className="cancel-button"
                      onClick={() => navigate('/login')}
                      disabled={isLoading}
                    >
                      Volver al inicio de sesión
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="save-button"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Registrando...
                        </>
                      ) : (
                        <>
                          <FaSave className="me-2" />
                          Registrarse
                        </>
                      )}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}
